<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-ban"></i> <ng-container i18n>Decline Booking Request</ng-container></h5>
  <button (click)="dialogRef.close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <mat-form-field2 class="mat-block">
      <mat-select formControlName="rejectionReason" placeholder="Reason for declining" i18n-placeholder required>
        <mat-option *ngFor="let item of reasons" [value]="item.id"> {{ item.label }}</mat-option>
      </mat-select>
    </mat-form-field2>
    <mat-form-field2 *ngIf="isNotComfortable" class="mat-block">
      <textarea
        matInput
        placeholder="Why are you declining this request?"
        i18n-placeholder
        required
        rows="3"
        [maxlength]="textMax"
        formControlName="rejectionReasonText"
        cdkTextareaAutosize
      ></textarea>
      <mat-hint align="start" i18n>Private, not shared with the guest</mat-hint>
      <mat-hint align="end">{{ form.get('rejectionReasonText').value?.length || 0 }} / {{ textMax }}</mat-hint>
    </mat-form-field2>
  </form>
  <p class="text-muted text-sm mt-3 mb-0 bdc-rtb-disclaimer">{{ disclaimer }}</p>
</div>
<div class="modal-footer">
  <button (click)="dialogRef.close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onDecline(form)" type="button" [disabled]="isLoading" class="btn btn-secondary-danger create-btn">
    <i class="fal fa-ban"></i> <ng-container i18n>Decline</ng-container>
  </button>
</div>
